import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@collaborate-health/uikit'

import { CertificatesDisplayType } from '../../constants'
import { Scope } from '../../enums'

import CertificatesGrid from '../CertificatesGrid'

export interface UserCertificatesDialogProps {
  open: boolean
  scope?: Scope
  user?: { Id: number; IdentityGuid: string }
  onClose: () => void
  onExited?: () => void
  displayType?: CertificatesDisplayType
}

const UserCertificatesDialog: React.FC<UserCertificatesDialogProps> = ({
  open,
  user,
  scope = Scope.Tenant,
  onClose,
  onExited,
  displayType = CertificatesDisplayType.User,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth='lg'
      TransitionProps={{ unmountOnExit: true, onExited }}
      height='70vh'
    >
      <DialogTitle>User certificates</DialogTitle>

      <DialogContent>
        <CertificatesGrid simpleView scope={scope} user={user} displayType={displayType} />
      </DialogContent>

      <DialogActions>
        <Button color='primary' onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UserCertificatesDialog

